export default __webpack_public_path__ + "static/BasierCircle-Bold-9c1bc4fd5b0e17dd67f6a16e45680e9c.woff";